import {
  ContentList,
  CONTENT_TYPES,
} from '@hivebrite/design-system/ContentList';

import { useForumContext } from 'hb-react/frontoffice/apps/Forum/contexts/ForumContext';
import type {
  Category,
  DiscussionCard,
} from 'hb-react/frontoffice/apps/Forum/types';

export interface WidgetSideProps {
  category: Category;
  discussions: DiscussionCard[];
}

const WidgetSide = ({ category, discussions }: WidgetSideProps) => {
  const { configUrls } = useForumContext();

  const data = discussions.map(
    // Remove comments & likes since they are not used in the ContentList
    ({ id, title, user, comments, likes, ...rest }) => ({
      hasUncroppedName: true,
      name: title,
      path: configUrls.discussionUrl(id),
      user: { ...user, path: Routes.user_path(user.id) },
      ...rest,
    }),
  );

  return (
    <ContentList
      contentType={CONTENT_TYPES.FORUM}
      title={category.name}
      data={data}
    />
  );
};

export default WidgetSide;
